import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useNotification } from '../hooks/useNotification';
import { projectsAPI } from '../services/api';
import { CheckCircle, XCircle, Users, ArrowRight } from 'lucide-react';

const Invite = () => {
  const { inviteCode } = useParams();
  const navigate = useNavigate();
  const { showSuccess, showError, showWarning } = useNotification();
  const [loading, setLoading] = useState(false);
  const [projectInfo, setProjectInfo] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    if (inviteCode) {
      handleAcceptInvite();
    }
  }, [inviteCode]);

  const handleAcceptInvite = async () => {
    try {
      setLoading(true);
      setError('');
      
      const response = await projectsAPI.acceptInvite(inviteCode);
      
      showSuccess(`Вы успешно присоединились к проекту: ${response.data.project_name}`);
      
      // Redirect to projects page after successful join
      setTimeout(() => {
        navigate('/projects');
      }, 2000);
      
    } catch (err) {
      const errorMessage = err.response?.data?.message || 'Не удалось принять приглашение';
      setError(errorMessage);
      showError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'var(--bg-primary)',
        flexDirection: 'column',
        gap: '20px'
      }}>
        <div style={{
          width: '40px',
          height: '40px',
          border: '4px solid #e5e7eb',
          borderTop: '4px solid #3b82f6',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }}></div>
        <div style={{ fontSize: '16px', color: 'var(--text-primary)' }}>
          Присоединение к проекту...
        </div>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'var(--bg-primary)',
        flexDirection: 'column',
        gap: '20px',
        padding: '20px'
      }}>
        <div style={{
          backgroundColor: 'var(--bg-secondary)',
          borderRadius: '12px',
          padding: '32px',
          maxWidth: '500px',
          width: '100%',
          textAlign: 'center',
          border: '1px solid var(--border-color)',
          boxShadow: 'var(--shadow)'
        }}>
          <XCircle size={48} color="#ef4444" style={{ marginBottom: '16px' }} />
          <h2 style={{
            fontSize: '24px',
            fontWeight: 'bold',
            color: 'var(--text-primary)',
            marginBottom: '12px'
          }}>
            Некорректная ссылка приглашения
          </h2>
          <p style={{
            fontSize: '16px',
            color: 'var(--text-secondary)',
            marginBottom: '24px',
            lineHeight: '1.5'
          }}>
            {error}
          </p>
          <button
            onClick={() => navigate('/projects')}
            style={{
              padding: '12px 24px',
              backgroundColor: '#3b82f6',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontSize: '14px',
              fontWeight: '500',
              cursor: 'pointer',
              transition: 'all 0.2s'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#2563eb';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#3b82f6';
            }}
          >
            Перейти к проектам
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'var(--bg-primary)',
      flexDirection: 'column',
      gap: '20px',
      padding: '20px'
    }}>
      <div style={{
        backgroundColor: 'var(--bg-secondary)',
        borderRadius: '12px',
        padding: '32px',
        maxWidth: '500px',
        width: '100%',
        textAlign: 'center',
        border: '1px solid var(--border-color)',
        boxShadow: 'var(--shadow)'
      }}>
        <CheckCircle size={48} color="#10b981" style={{ marginBottom: '16px' }} />
        <h2 style={{
          fontSize: '24px',
          fontWeight: 'bold',
          color: 'var(--text-primary)',
          marginBottom: '12px'
        }}>
          Вы успешно присоединились к проекту!
        </h2>
        <p style={{
          fontSize: '16px',
          color: 'var(--text-secondary)',
          marginBottom: '24px',
          lineHeight: '1.5'
        }}>
          Вы успешно присоединились к проекту. Сейчас будет выполнен переход на страницу проектов.
        </p>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px',
          color: 'var(--text-secondary)',
          fontSize: '14px'
        }}>
          <ArrowRight size={16} />
          Переход к проектам...
        </div>
      </div>
    </div>
  );
};

export default Invite;
